import axios from "axios";
import { log } from "@/plugins/consoleLogger";
import { tariffsUrl } from "../moduleUrls";

const fetchTariff = async (data) => {
  try {
    const res = await axios.get(
      tariffsUrl + `/tariffs/${data.country_code}/${data.party_id}/${data.tariff_id}`,
      {
        timeout: 30000
      }
    );

    if (res.status === 200) {
      return res.data.data;
    } else {
      throw new Error("Unable to acess Tariff API");
    }
  } catch (err) {
    log("error", `Failed Backoffice call with: ${err.toString()}`);
    throw new Error("Unable to acess Tariff API");
  }
};

const getTariff = async (countryCode, partyId, tariff_ids) => {
  let tariffs_array = [];
  let final_tariff
  let tariffFound 
  if (tariff_ids == undefined ||  tariff_ids.length == 0) {
    tariffFound == undefined
  }
  else {
    for (let index = 0; index < tariff_ids.length; index++) {
      try {
        const tariff = await fetchTariff({
          country_code: countryCode,
          party_id: partyId,
          tariff_id: tariff_ids[index]
        })
        if (tariff) { tariffs_array.push(tariff); }
      } catch (error) {
        log("error", "unable to find tariff " + tariff_ids[index]);
      }
    }
    
    tariffFound = tariffs_array.find(element => element.type == "AD_HOC_PAYMENT");
    if (!tariffFound) {
      tariffFound = tariffs_array.find(element => element.type == "REGULAR");
    }
    if (!tariffFound) {
      tariffFound = tariffs_array.find(element => !element.type);
    }
  }
  
  if (tariffFound == undefined) {
    final_tariff = {
      currency: "",
      fixed_price: 0,
      energy_price: 0,
      time_price: 0
    };
  }
  else {
    const energyComponent = tariffFound.elements.flatMap(element => element.price_components).find(component => component.type === 'ENERGY');
    const timeComponent = tariffFound.elements.flatMap(element => element.price_components).find(component => component.type === 'TIME');
    const flatComponent = tariffFound.elements.flatMap(element => element.price_components).find(component => component.type === 'FLAT');

    final_tariff = {
      currency: tariffFound.currency,
      fixed_price: flatComponent ? flatComponent.price: 0 ,
      energy_price: energyComponent ? energyComponent.price : 0,
      time_price: timeComponent ? (timeComponent.price/60) : 0,
    };

    if (flatComponent && flatComponent.vat) { final_tariff.fixed_price = final_tariff.fixed_price * (100 + flatComponent.vat) / 100; }
    if (energyComponent && energyComponent.vat) { final_tariff.energy_price = final_tariff.energy_price * (100 + energyComponent.vat) / 100; }
    if (timeComponent &&timeComponent.vat) { final_tariff.time_price = final_tariff.time_price * (100 + timeComponent.vat) / 100; }
    
  }

  return final_tariff;
}

export { getTariff, fetchTariff };
